import type { IconProps } from '../types/IconProps.ts';
export const SparklesText: IconProps = {
    name: 'SparklesText',
    children: [
        `<path d="m15.99 6.8-1.96-.83a.05.05 0 0 1 0-.1l1.96-.83a2 2 0 0 0 1.05-1.05l.84-1.96a.05.05 0 0 1 .09 0l.84 1.96a2 2 0 0 0 1.05 1.05l1.96.84c.04.01.04.07 0 .09l-1.96.84a2 2 0 0 0-1.05 1.05l-.84 1.96a.05.05 0 0 1-.1 0l-.83-1.96a2 2 0 0 0-1.05-1.05ZM3 5h6M3 9h8M3 13h15.5M3 17h12M3 21h17.5" />`,
    ]
};